import React from 'react';
import FieldLockOverlay from '../record/FieldLockOverlay';
import TagsWidget from '../record/TagsWidget';
import { FieldInput } from '../../pages/RecordCreate';

export default function WidgetRenderer({ widget, fields, fieldData, onChange, errors, readOnly, recordId, fieldLocks, incomingChanges, onFieldFocus, onFieldBlur, onFieldChange, clearIncomingChange, isLockedByOther }) {
  switch (widget.type) {
    case 'field': {
      const field = fields.find(f => f.id === widget.config?.field_id);
      if (!field) {
        return (
          <div className="border-2 border-dashed border-red-200 rounded-lg p-3 text-sm text-red-400">
            Field not found
          </div>
        );
      }
      const displayField = {
        ...field,
        label: widget.config?.label_override || field.label,
        help_text: widget.config?.help_text_override || field.help_text,
      };
      const lockedBy = isLockedByOther?.(field.id);
      const incoming = incomingChanges?.[field.id];
      return (
        <FieldLockOverlay
          fieldName={field.id}
          lock={lockedBy}
          incomingChange={incoming}
          onFocus={() => onFieldFocus?.(field.id)}
          onBlur={() => onFieldBlur?.(field.id)}
          onAcceptChange={() => {
            if (incoming) {
              onChange(field.id, incoming.value);
              clearIncomingChange?.(field.id);
            }
          }}
          isReadOnly={readOnly || widget.config?.read_only}
        >
          <FieldInput
            field={displayField}
            value={fieldData[field.id]}
            onChange={(val) => {
              onChange(field.id, val);
              onFieldChange?.(field.id, val);
            }}
            error={errors[field.id]}
            readOnly={readOnly || widget.config?.read_only || !!lockedBy}
            recordId={recordId}
            fieldData={fieldData}
            fields={fields}
          />
        </FieldLockOverlay>
      );
    }

    case 'section_header':
      return (
        <div className="pt-2 pb-1">
          <h3 className="text-sm font-semibold text-gray-800 border-b border-gray-200 pb-1">
            {widget.config?.text || 'Header'}
          </h3>
          {widget.config?.subtitle && (
            <p className="text-xs text-gray-500 mt-1">{widget.config.subtitle}</p>
          )}
        </div>
      );

    case 'divider':
      return <hr className="border-gray-200 my-2" />;

    case 'static_text':
      return (
        <div className="bg-blue-50 border border-blue-200 rounded-lg px-4 py-3 text-sm text-blue-700">
          {widget.config?.text || ''}
        </div>
      );

    case 'tags':
      return (
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            {widget.config?.label || 'Tags'}
          </label>
          <TagsWidget recordId={recordId} category={widget.config?.category} />
        </div>
      );

    case 'spacer':
      return <div style={{ height: widget.config?.height || 24 }} />;

    default:
      return (
        <div className="border-2 border-dashed border-gray-200 rounded-lg p-3 text-sm text-gray-400">
          Unknown widget: {widget.type}
        </div>
      );
  }
}
